// action types
import { createRequestTypes } from "../../utils";

export const FETCH_BREVO_FOLDERS = createRequestTypes("FETCH_BREVO_FOLDERS");

export const fetchBrevoFoldersRequest = () =>
    ({ type: FETCH_BREVO_FOLDERS.REQUEST });

export const fetchBrevoFoldersSuccess = (data) =>
    ({ type: FETCH_BREVO_FOLDERS.SUCCESS, payload: { data } });

export const fetchBrevoFoldersFailure = (error) =>
    ({ type: FETCH_BREVO_FOLDERS.FAILURE, payload: { error } });